export class TokenInfo {
    token: string;
    expiryDate: any;
    constructor(token: string, expiryDate: any) {
        this.token = token;
        this.expiryDate = expiryDate;
    }
}
